import { executeFetch } from 'api';
import type { IndexReference } from 'types';

const lookupVehicleRegNumber = (
  vrn: string,
  indexReference: IndexReference
): Promise<any> => executeFetch(`vehicles/vrm/${vrn}`, { indexReference });

export default lookupVehicleRegNumber;
